export default {

	props: {
		party: Number,
		buttonTitle: String,
		campaignTitle: String,
		emptyTitle: String
	},
	data() {
		return {
			campaign: 0,
			errorForm: "",
			errorProperty: "",
			campaignList: []
		}
	},
	computed: {
		disabledButton() {
			return this.campaignList.length===0;
		},
		isErrorForm() {
			return  this.errorForm !== null && this.errorForm !== undefined && this.errorForm.length>0;
		},
		isErrorProperty() {
			return  this.errorProperty !== null && this.errorProperty !== undefined && this.errorProperty.length>0;
		}
	},
	methods: {
		addToCampaign() {
			this.errorForm="";
			if (this.campaign===0) {
				this.errorProperty=this.emptyTitle;
			}
			else {
				this.errorProperty="";
				var data = {
				  "campaign": this.campaign,
				  "party": this.party
				}
				fetch("./api/campaignparties", {
				  method: 'POST',
				  headers: { 'Content-Type': 'application/json; charset=utf-8' },
				  body: JSON.stringify(data)
				})
				.then(response => {
					if (response.ok) {
						//remove added campaign from list
						this.removeFromList(this.campaign);
						this.campaign=0;
						//refresh table
						this.$emit('refresh');
					}
					else {
						console.error('Error:', response.status);
						this.errorForm="RestApi point return status:"+response.status;
					}
				})
				.catch((error) => {
				  console.error('Error:', error);
				  this.errorForm="Error to fetch restApi point";
				});
			}
		},
		loadData() {
			this.campaignList=[];
			return fetch("./api/campaigns/enterable?party="+this.party)
			.then(response => response.json())
			.then(data => {
				//console.log("Loaded data:"+JSON.stringify(data));
				if (data !== null && data !== undefined) {
					this.campaignList=data;
				}
				else {
					this.errorForm = "Loaded campaign list is invalid";
				}
			})
			.catch((error) => {
				console.log("Error loading campaign list:"+error);
				this.errorForm = error;
			});
		},
		removeFromList(campaignId) {
			this.campaignList = this.campaignList.filter(item=>item.id!==campaignId);
		}
	},
	mounted() {
		this.loadData();
	},
	template:
`
<div v-if="isErrorForm" class="errors">
	<span class="perr">{{errorForm}}</span>
</div>
<table class="form">
	<tbody class="first-body last-body">
	<tr><td>
		<span style="white-space: nowrap" v-html="campaignTitle"></span>
		&nbsp;
		<select v-model.number="campaign">
		  <option value="0">-</option>
		  <option v-for="item in campaignList" :value="item.id">
			{{ item.name }}
		  </option>
		</select>
		&nbsp;
		<button class="button" @click="addToCampaign" :disabled='disabledButton'>
			{{buttonTitle}}
		</button>
		<span v-if="isErrorProperty" class="perr">{{errorProperty}}</span>
	</td></tr>
	</tbody>
</table>`
}
